import { createStore } from 'vuex'
import HarmonicSerie from './HarmonicSerie'

export default createStore({
  state: {
    harmonicsCalculator: {
      series: <HarmonicSerie[]> [
        
      ]
    }
  },
  getters: {
   
      
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
